import {get as httpGet, del as httpDel, post as httpPost} from "./BackendService";

export interface IgnoredUrl {
  id: number;
  user_id: number;
  type: string;
  pattern: string;
  response: string;
  created_at: Date;
}

export const getIgnoredUrls = (userId: number): Promise<IgnoredUrl[]> => {
  return httpGet<IgnoredUrl[]>(`/users/${userId}/ignored-urls`);
};

export const deleteIgnoredUrl = (userId: number, ignoredUrlId: number): Promise<void> => {
  return httpDel<void>(`/users/${userId}/ignored-urls/${ignoredUrlId}`);
};

export const addIgnoredUrl = (userId: number, type: string, pattern: string): Promise<IgnoredUrl> => {
  return httpPost<IgnoredUrl>(`/users/${userId}/ignored-urls`, {type, pattern});
};
